<template>
  <div class="hello">
    <md-tabs>
      <md-tab id="tab-home" md-label="Home" ></md-tab>
      <md-tab id="tab-pages" md-label="Pages" ></md-tab>
      <md-tab id="tab-posts" md-label="Posts" ></md-tab>
      <md-tab id="tab-favorites" md-label="Favorites"></md-tab>
    </md-tabs>

   
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
